import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ReportingCountry from '../Components/ChapterTwo/ReportingCountry';
import CountryOfOrigin from '../Components/ChapterTwo/CountryOfOrigin';
import classes from '../Style/ChapterTwo.scss';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const ChapterTwo = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="fullWidth">
                    <Tab className={value === 0 ? 'selected-tab-1' : 'unselected'} label="REPORTING COUNTRY" {...a11yProps(0)} />
                    <Tab className={value === 1 ? 'selected-tab-2' : 'unselected'} label="COUNTRY OF ORIGIN" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <ReportingCountry />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <CountryOfOrigin />
            </TabPanel>
        </Box>
    );
}


export default ChapterTwo;